class CustomPaginationController {
   $scope: any
   constructor($scope: any, translationService:TranslationService) {
      this.$scope = $scope
      this.$scope.i18n = translationService
   }
}

CustomPaginationController.$inject = ['$scope', 'translationService']

angular.module('summonApp.controllers')
   .controller('CustomPaginationCtrl', CustomPaginationController)
